import { CHANGE_LOCKOUT_STEP } from 'actions'

const initialState = {
  step: 'initial_prompt'
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case CHANGE_LOCKOUT_STEP:
      return {
        ...state,
        step: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/lockouts.js